module.exports = __webpack_public_path__ + "img/icon1.1b829339.png";